interface IconProps {
  color?: string
  className?: string
}

export default function HammerIcon({ color: _color, className }: IconProps) {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.0625 6.53125C18.25 6.75 18.25 7.0625 18.0625 7.25L15.2188 10.0938C15.0312 10.2812 14.7188 10.2812 14.5312 10.0938L13.8125 9.375C13.625 9.1875 13.625 8.875 13.8125 8.65625L14.1562 8.3125L13.25 7.40625C12.5938 7.59375 11.875 7.40625 11.3438 6.90625L9.8125 5.375C9.4375 5 9.21875 4.46875 9.21875 3.9375V3.375L6.375 1.9375C8.34375 0 11.5 0 13.4688 1.9375L14.875 3.375C15.4062 3.875 15.5625 4.625 15.375 5.28125L16.2812 6.1875L16.6562 5.84375C16.8438 5.65625 17.1562 5.65625 17.3438 5.84375L18.0625 6.53125ZM9.09375 6.0625L10.625 7.59375C10.75 7.71875 10.875 7.8125 11 7.90625L3.5625 15.875C2.8125 16.6562 1.53125 16.6875 0.78125 15.9062C0 15.1562 0.03125 13.875 0.8125 13.125L8.78125 5.6875C8.875 5.8125 8.96875 5.96875 9.09375 6.0625Z"
        fill="white"
      />
    </svg>
  )
}
